<template>
  <div style="max-width: 1200px">
    <div class="section upload" style="margin-top: -50px">
      <h1 class="is-size-4" style="margin-bottom: 20px">
        <translate>
          upload.heading
        </translate>
      </h1>

      <div v-html="$gettext('upload.infotext')">
      </div>

      <a :href="'mailto:fob@uni-leipzig.de?subject='+subject+'&body='+text">
        <b-icon icon="envelope" size="is-small"> </b-icon> <translate>upload.linktext</translate>
      </a>
    </div>
  </div>
</template>

<script>

import DynamicTitle from '@/components/mixins/DynamicTitle'

export default {
  mixins: [DynamicTitle],
  data () {
    return {
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.upload'
      }
    }
  },
  computed: {
    subject () {
      return encodeURIComponent(`Publikationsupload, ${this.$store.getters['user/selectedOrga'].name}`)
    },
    text () {
      return encodeURIComponent(`Im Anhang / attachment eine Publikationsliste für die Organisationseinheit ${this.$store.getters['user/selectedOrga']._stringRep}`)
    }
  }
}
</script>

<style>
.upload {
  max-width: 1000px;
  padding: 3em 1.5rem;
}
.upload p {
  margin-bottom: 1em;
}
.upload ul {
  list-style-type: disc;
  list-style-position: outside;
  padding-left: 2em;
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Upload.vue